import template from './filters-view.html';
import moment from 'moment';

// Constants
const CUSTOM_REGEX_MATCH = /Custom.*/;
const DATE_FILTER_NAME = 'Date Filter';
const DATE_START_FILTER = 'Start Date';
const DATE_END_FILTER = 'End Date';
const CONTRACT_START_FILTER = 'Contract Start';
const CONTRACT_END_FILTER = 'Contract End';
const RADIO_BUTTON_TYPE_FILTER = 'radio_button';
const MULTI_SELECT_TYPE_FILTER = 'multiselect';
const INPUT_TEXT_TYPE = 'input_text';

class FiltersViewController {
  constructor($timeout) {
     'ngInject';
    this.selectedParameters = {};
    this.$timeout = $timeout;

    this.dateFilterName = DATE_FILTER_NAME;
    this.startDateName = DATE_START_FILTER;
    this.endDateName = DATE_END_FILTER;
    this.contractStartStr = CONTRACT_START_FILTER;
    this.contractEndStr = CONTRACT_END_FILTER;
    this.radioButtonType = RADIO_BUTTON_TYPE_FILTER;
    this.multiSelectType = MULTI_SELECT_TYPE_FILTER;
    this.inputTextType = INPUT_TEXT_TYPE;

    // For date-filter
    // 3 Months limit ( tableau side )
    this.startDateVal = moment()
      .subtract(1, 'day')
      .toDate();
    this.endDateVal = moment().toDate();

    this.startDateOptions = {minDate: moment().subtract(3, 'months'), maxDate: moment().subtract(1, 'day')};
    this.endDateOptions = {minDate: this.startDateVal, maxDate: moment()};
  }
  $onInit() {
    // Setting callback from parent to child to update the values.
    this.updateFilter = filters => this.updateFilters(filters);
    this.loaded = true;
    // Ignore those filters as they have different layout
    this.loopIgnoreFilters = {
      [DATE_START_FILTER]: true,
      [DATE_END_FILTER]: true,
      [CONTRACT_END_FILTER]: true
    };
    this.filtersLoading = true;
  }
  $onChanges() {
    this.tableauFilters = this.filters || [];
  }
  isCustomDate(filterName) {
    return CUSTOM_REGEX_MATCH.test(this.selectedParameters[filterName] || '');
  }

  updateFilters(valueFilters) {
    this.$timeout(() => (this.filtersLoading = false), 100);
    this.tableauFilters = valueFilters;
  }

  filterHasChanged(filterObject) {
    this.filterChanged({filter: filterObject});
  }

  parameterChanged(parameterObject) {
    const {name: parameterName, value} = parameterObject;

    if (parameterName && value) {
      this.selectedParameters[parameterName] = value;
    }

    this.changeParameter({parameter: parameterObject});
  }

  // Date update val
  updateStartDate() {
    this.endDateOptions.minDate = this.startDateVal;
    this.changeParameter({parameter: {name: DATE_START_FILTER, value: this.startDateVal}});
  }
  updateEndDate() {
    this.startDateOptions.maxDate = this.endDateVal;
    this.changeParameter({parameter: {name: DATE_END_FILTER, value: this.endDateVal}});
  }
}
export default {
  template,
  controller: FiltersViewController,
  controllerAs: 'vm',
  bindings: {
    filters: '<',
    filterChanged: '&',
    changeParameter: '&',
    updateFilter: '='
  }
};
